import {Serializables} from "../../../typescript-plugin/entities/Serializables";
import {Employee} from "./Employee";

export class Employees extends Serializables<Employee>{

    public SetOccasions(employees:Array<Employee>){
        this.items = employees;
    }

    protected CreateEntity(): Employee {
        return new Employee();
    }
}



// WEBPACK FOOTER //
// C:/Users/Benoit/WebstormProjects/schiltz/server/src/base/entities/employee/Employees.ts